import React from "react";
import { useFormikContext } from "formik";
import get from "lodash/get";
import SectionBezel from "components/SectionBezel";
import DocsInfoButton from "components/DocsInfoButton";
import { LEARN_PATHS } from "utils/paths";
import {
  PAYMENT_METHODS_DOCS_INFO,
  SETUP_PAYMENT_METHODS_DOCS_INFO
} from "constants/docs";
import Methods from "../Payment/Methods";
import { getFieldPath } from "utils/form";
import { PAYMENT_MODE } from "utils/constants/payment";

const PaymentMethodFields = ({ name, open = false }) => {
  const { values } = useFormikContext();

  const modePath = getFieldPath(name, "mode");
  const modeValue = get(values, modePath, []);
  const isSetupMode = modeValue === PAYMENT_MODE.SETUP;
  return (
    <SectionBezel
      header="Payment methods"
      expandable
      open={open}
      action={
        <DocsInfoButton
          slides={
            isSetupMode
              ? SETUP_PAYMENT_METHODS_DOCS_INFO
              : PAYMENT_METHODS_DOCS_INFO
          }
          url={LEARN_PATHS.PAYMENT_LINKS.PAYMENT_METHODS_RESTRICTIONS}
        />
      }
    >
      <Methods name={name} title="Methods" hideToggle />
    </SectionBezel>
  );
};

export default PaymentMethodFields;
